/*
 * Usage
 * =====
 * ```svelte
 * <script>
 * import toggleState from 'lib/toggleState.svelte';
 * let showMessage = toggleState(false)
 * </script>
 * 
 * {#if showMessage.value}
 *   I am a message <button onclick={showMessage.toggle}>Hide</button>
 * {:else}
 *   <button onclick={showMessage.toggle}>Show Message</button>
 * {/if}
 * ```
 */
export default function toggleState(defaultValue = true) {
  return new ToggleState(defaultValue)
}

export class ToggleState {
  value = $state<boolean>()
  toggle: (e?: Event) => void;

  constructor(defaultValue){
    this.value = defaultValue
    this.toggle = (e?: Event) => {
      e?.preventDefault?.();
      this.value = !this.value;
    }
  }
}